class PastilleFilterBlock {
  constructor(el) {
    this.el = el;
    this.gridSelector = el.dataset.gridSelector || '#ProductGridContainer';
    this.filtersEl = el.querySelector('.pastille-filters');
    this.filtersId = this.filtersEl.id;
    this.bind();
    window.addEventListener('popstate', () => this.load(location.href, false));
  }

  bind() {
    // délégation sur le wrapper : pas besoin de réattacher après un remplacement du contenu interne
    this.el.addEventListener('click', (e) => {
      const link = e.target.closest('a.pastille');
      if (!link || link.classList.contains('pastille--disabled')) return;
      e.preventDefault();
      this.load(link.href, true);
    });
  }

  load(url, pushHistory) {  
    document.body.classList.add('pastille-loading');

   
    console.log('URL fetch:', url);


    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = doc.querySelector(this.gridSelector);

console.log('nb produits dans newGrid:', newGrid ? newGrid.querySelectorAll('.product-card, [data-product-id]').length : 'grid introuvable');

        const currentGrid = document.querySelector(this.gridSelector);
        if (newGrid && currentGrid) currentGrid.replaceWith(newGrid);

        const newFilters = doc.getElementById(this.filtersId);
        if (newFilters) this.filtersEl.replaceWith(newFilters);
        this.filtersEl = document.getElementById(this.filtersId);

        if (pushHistory) history.pushState({}, '', url);
        document.body.classList.remove('pastille-loading');
      })
      .catch((err) => {
        console.error('Erreur filtre AJAX', err);
        document.body.classList.remove('pastille-loading');
      });
  }
}



document.querySelectorAll('[data-pastille-filters]').forEach((el) => new PastilleFilterBlock(el));